import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {isObjectEmpty, arrayToObject, toArray, buildUniqueArrayFromField, filter} from '../../../Utils';
import {pipe, map, sort, toTime, toTimeType} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    function getTableData(){    
        const {summaryData, classData} = pageState;
        if(isObjectEmpty(summaryData)) return;
        
        let classIDList = buildUniqueArrayFromField(toArray(classData), 'ClassID'); // get all classIDs that have students that have marks
        const concatStudents = xs => xs.reduce((acc, x) => x && acc.concat(x.students), []);
        let allStudentsList = pipe( // build a list of all the student from all the classes that have marks
                map(classID => classData[classID]),
                concatStudents,
                //sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() === b.Name.toUpperCase() ? -1 : 0))
            )(classIDList); 

        allStudentsList = allStudentsList.filter(e=>e);
        let allStudentsDic = arrayToObject(allStudentsList,'StudentID'); //organize the list of students by ID
        let studentIDList = buildUniqueArrayFromField(toArray(summaryData), 'StudentID'); // find all the student IDs for the classes with marks.
        let studentList = pipe( // find the marks per student by iterating the studentIDList
            filter(studID => allStudentsDic[studID]), // skip broken
            map(studID => allStudentsDic[studID]), // convert the ID array into a Student Record Array
            sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() < b.Name.toUpperCase() ? -1 : 0)), // sort students by name
            map(studRec => { // combine the summary marks for each student
                return {studData: studRec, marks: summaryData.reduce((acc, summaryRec) => {
                        if(studRec.StudentID === summaryRec.StudentID){ // if this summary mark is for this student then add it to their mark
                            acc.QuestionsRight += parseInt(summaryRec.QuestionsRight);
                            acc.QuestionsAttempted += parseInt(summaryRec.QuestionsAttempted);
                            acc.time += parseInt(summaryRec.CumulativeTime)+parseInt(summaryRec.CumulativeIdleTime); 
                            acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
                            acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
                            acc.logins ++;
                        }
                        return acc;
                    // create a default mark of nothing
                    },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0})
                };
            })
        )(studentIDList); 

        return studentList;   
    }
    
    return <><StudentsComp tableData={getTableData()} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const StudentsComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col  style={{textAlign: 'left'}} xs='4'> Students</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Logins</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions Correct</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Percent</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}

            {titleRow}
            {tableData.map((StudentRec, stud_i) => <span key={stud_i}>
                <Row><Col xs='12' style={{fontWeight:'bold'}} >{StudentRec.Name}</Col></Row>
                <ProgramRow data={{title: StudentRec.studData.Name, logins: StudentRec.marks.logins, correct: StudentRec.marks.correct, percent:StudentRec.marks.percent, time:StudentRec.marks.time}} />
                </span>
            )}

            <Row><Col xs='12'></Col></Row>
            <ProgramRow data={{title: 'Total', logins: totals.logins, correct: totals.correct, percent:totals.percent, time:totals.time}} fontWeight={'bold'}/>

        </Container>
    );
};
StudentsComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const { title, logins, correct, percent, time} = props.data;

    return (
        <Row>
            <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='4'> {title} </Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{logins}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{correct}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{isNaN(percent)?'-':`${percent}%`}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(time)} {toTimeType(time)}</Col>
        </Row>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
